import { render, staticRenderFns } from "./HotelsPage.vue?vue&type=template&id=47f71575&scoped=true"
import script from "./HotelsPage.vue?vue&type=script&lang=js"
export * from "./HotelsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f71575",
  null
  
)

export default component.exports